import yup from '../../../config/yup';

export const leadSquaredWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('leadSquaredWriter'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  connectionKey: yup.string(),
  onError: yup.string(),
  properties: yup.object().shape({
    interval: yup.string(),
    count: yup.string(),
    path: yup.string().required('Path is required'),
  }),
});
